export default __webpack_public_path__ + "static/media/medication_detail_icon.d5c4b691.svg";